// Howie Knowledge Graph — constants and configuration

/** Background color for the galaxy canvas */
export const BG_COLOR = '#0a0a0f';

/**
 * Colors assigned to Neo4j domains (sorted alphabetically).
 * BEHAVIOR=0, CULTURE=1, LEADERSHIP=2, SELF=3, SOCIETY=4, TRUST=5
 */
export const DOMAIN_COLORS = [
  '#e57373', // BEHAVIOR — warm red
  '#4fc3f7', // CULTURE — cool blue
  '#ffb74d', // LEADERSHIP — amber
  '#ce93d8', // SELF — lavender
  '#81c784', // SOCIETY — sage green
  '#4dd0e1', // TRUST — teal
];

/** Domain labels matching DOMAIN_COLORS index order */
export const DOMAIN_LABELS = [
  'Behavior',
  'Culture',
  'Leadership',
  'Self',
  'Society',
  'Trust',
];

/** Colors for relationship types on links and in concept panel */
export const RELATIONSHIP_COLORS: Record<string, string> = {
  RESONATES_WITH: '#4fc3f7',   // blue
  CONTRADICTS: '#ef5350',       // red
  ENABLES: '#81c784',           // green
  DEVELOPS: '#ffb74d',          // amber
} as const;

/** Labels for relationship types */
export const RELATIONSHIP_LABELS: Record<string, string> = {
  RESONATES_WITH: 'Resonates',
  CONTRADICTS: 'Contradicts',
  ENABLES: 'Enables',
  DEVELOPS: 'Develops',
} as const;

/** Galaxy D3 force simulation parameters */
export const GALAXY_CONFIG = {
  /** Canonical node radius range (scaled by importance_score) */
  canonicalMinRadius: 2,
  canonicalMaxRadius: 9,
  /** Number of paradigm groups */
  paradigmCount: 3,
};

/** Colors for canonical stance labels */
export const STANCE_COLORS = {
  ENDORSED: '#4caf50',
  CRITIQUED: '#ef5350',
  ANALYZED: '#90a4ae',
} as const;

export const STANCE_LABELS = {
  ENDORSED: 'Endorsed',
  CRITIQUED: 'Critiqued',
  ANALYZED: 'Analyzed',
} as const;

/** Visual constants */
export const TEXT_PRIMARY = '#f0ebe3';
export const TEXT_SECONDARY = '#a8b4c4';
